// extracted by mini-css-extract-plugin
export default {"createGroupModal":"GroupCreateModal_createGroupModal__kip-a"};